import { callRpc } from './base';

export interface CrawlHealthRow {
  programId: string;
  programName: string | null;
  lastSnapshotAt: string | null;
  snapshotCount: number;
  snapshotCountWindow: number;
  lastCrawlJobId: string | null;
  lastCrawlStatus: string | null;
  firecrawlCreditsUsed: number | null;
  firecrawlProxyTier: string | null;
  firecrawlPayloadIds: string[];
  firecrawlJobId: string | null;
  mapRunId: string | null;
  lastMapRunAt: string | null;
  mapLinkCount: number;
}

export interface CrawlHealthParams {
  days: number;
  limit: number;
  programId?: string;
}

interface CrawlHealthRowRaw {
  program_id: string;
  program_name: string | null;
  last_snapshot_at: string | null;
  snapshot_count: number;
  snapshot_count_window: number;
  last_crawl_job_id: string | null;
  last_crawl_status: string | null;
  firecrawl_credits_used: string | number | null;
  firecrawl_proxy_tier: string | null;
  firecrawl_payload_ids: string[] | null;
  firecrawl_job_id: string | null;
  map_run_id: string | null;
  last_map_run_at: string | null;
  map_link_count: number | null;
}

const coerceNumber = (value: string | number | null | undefined): number | null => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export async function fetchCrawlHealthReport(params: CrawlHealthParams): Promise<CrawlHealthRow[]> {
  const { days, limit, programId } = params;
  const rpcParams: Record<string, unknown> = {
    p_days: days,
    p_limit: limit,
  };

  if (programId) {
    rpcParams.p_program_id = programId;
  }

  return callRpc<CrawlHealthRowRaw[], CrawlHealthRow[]>(
    'crawl_health_report',
    {
      params: rpcParams,
      transform: (rows) => rows.map((row) => ({
        programId: row.program_id,
        programName: row.program_name,
        lastSnapshotAt: row.last_snapshot_at,
        snapshotCount: row.snapshot_count ?? 0,
        snapshotCountWindow: row.snapshot_count_window ?? 0,
        lastCrawlJobId: row.last_crawl_job_id,
        lastCrawlStatus: row.last_crawl_status,
        firecrawlCreditsUsed: coerceNumber(row.firecrawl_credits_used),
        firecrawlProxyTier: row.firecrawl_proxy_tier,
        firecrawlPayloadIds: Array.isArray(row.firecrawl_payload_ids) ? row.firecrawl_payload_ids : [],
        firecrawlJobId: row.firecrawl_job_id ?? null,
        mapRunId: row.map_run_id ?? null,
        lastMapRunAt: row.last_map_run_at ?? null,
        mapLinkCount: row.map_link_count ?? 0,
      })),
    },
  );
}
